var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlass2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 50,
    viewBox: "0 0 38 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15034_2035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.7969 2.92578L35.712 41.0712C35.712 41.0712 34.8585 49.1887 26.7139 49.7583C24.7265 49.7583 15.1595 49.8525 11.6562 49.9509C10.0468 49.9509 1.71114 49.5698 1.71114 36.871C1.3413 24.074 0.203332 2.92578 0.203332 2.92578C0.203332 2.92578 -0.552605 5.35981 18.4311 5.64665C23.8771 5.59747 36.281 5.45406 37.7969 2.92578Z",
    fill: "#CFE1EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.771484 15.8176C0.771484 15.8176 7.73341 14.8629 11.6147 16.4856C13.1753 17.0101 15.9227 17.5837 18.3368 16.0061C19.8528 15.1948 21.8401 14.24 26.4814 15.8627C27.8551 16.3421 30.4115 16.674 32.5899 16.0061C33.6791 15.7685 37.0889 15.7685 37.0889 15.7685L35.8087 39.6867C35.8087 39.6867 35.9509 47.0871 29.4158 49.2343C28.7533 49.472 27.5219 49.808 25.819 49.7588C23.8763 49.9022 17.2029 49.808 13.2729 49.9965C11.7122 49.9965 8.44464 50.0907 6.02646 48.1812C4.604 46.8453 2.14517 44.8866 1.66967 38.0599C1.52742 31.6142 0.771484 15.8135 0.771484 15.8135V15.8176Z",
    fill: "#7257D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.677 21.2598H30.6729C29.7975 21.2598 29.0879 21.9753 29.0879 22.8579V40.2853C29.0879 41.1679 29.7975 41.8834 30.6729 41.8834H30.677C31.5524 41.8834 32.262 41.1679 32.262 40.2853V22.8579C32.262 21.9753 31.5524 21.2598 30.677 21.2598Z",
    fill: "#AE9BF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9999 5.64681C29.3811 5.64681 37.7967 4.42864 37.7967 2.92594C37.7967 1.42325 29.3811 0.205078 18.9999 0.205078C8.61874 0.205078 0.203125 1.42325 0.203125 2.92594C0.203125 4.42864 8.61874 5.64681 18.9999 5.64681Z",
    fill: "#CFE1EB",
    stroke: "#7257D7",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15034_2035"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlass2);
export default __webpack_public_path__ + "static/media/glass2.97254d627c880f85622844931262f78f.svg";
export { ForwardRef as ReactComponent };